import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import api from '../services/api';

const Berita = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.getAllBerita();
      setData(response);
    } catch (err) {
      setError('Gagal memuat data berita');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredData = data.filter(
    (item) =>
      item.judul.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.isi.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Navbar />
      <div className="w-full py-6 px-4 lg:px-8 xl:px-16">
        <div className="flex flex-col lg:flex-row gap-6">

          {/* Sidebar */}
          <div className="lg:w-1/4 w-full bg-white p-4 shadow rounded">
            <h2 className="text-lg font-bold mb-4">Pencarian</h2>
            <input
              type="text"
              placeholder="Masukkan kata kunci"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded mb-4"
            />

            <h2 className="text-lg font-bold mb-4">Latest Posts</h2>
            {error && <p className="text-red-500 mb-2">{error}</p>}
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="space-y-4">
                {filteredData.slice(0, 5).map((post) => (
                  <div key={post.id} className="flex space-x-3">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}/public/upload/${post.gambar.filename}`}
                      alt={post.judul}
                      className="w-16 h-16 object-cover rounded"
                    />
                    <div>
                      <Link to={`/berita/${post.id}`} className="font-semibold text-sm hover:text-blue-600">
                        {post.judul}
                      </Link>
                      <p className="text-xs text-gray-500">
                        📅 {new Date(post.createdAt).toLocaleDateString('id-ID', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Main Content */}
          <div className="lg:w-3/4 w-full">
            {filteredData.length === 0 && !loading ? (
              <p className="text-center text-gray-600 mt-10">Tidak ada berita yang cocok dengan pencarian.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {filteredData.map((news) => (
                  <div key={news.id} className="bg-white shadow rounded overflow-hidden">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}/public/upload/${news.gambar.filename}`}
                      alt={news.judul}
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-4">
                      <h3 className="font-bold text-lg mb-2">
                        <Link to={`/berita/${news.id}`} className="hover:text-blue-600">
                          {news.judul}
                        </Link>
                      </h3>
                      <p className="text-sm text-gray-600">{news.isi.substring(0, 100)}...</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Berita;
